import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { isPartialDate } from 'neuro-utils';
import { formatPartialDate } from 'Utility/date';
import TileContentMaker from 'Components/DashboardTile/TileContentMaker';
import { sortDocumentsDescending } from 'Utility/documentHandling';
import { uhdrsMotorRatingScale } from 'neuro-schemas';

const { calculateScore } = uhdrsMotorRatingScale;

const MotorFuncHuntDash = ({ documents }: IOwnProps): React.JSX.Element => {
  const docs = documents.sort(sortDocumentsDescending);
  return (
    <TileContentMaker
      type="recentList"
      data={docs.map(d => ({
        date: isPartialDate(d.date) ? formatPartialDate(d.date) : '',
        title: <FormattedMessage id="motorFunctionHuntington.uhdrs" />,
        value: calculateScore(d) ?? '-',
        key: d._id,
      }))}
    />
  );
};

interface IOwnProps {
  documents: Array<IDocumentWithTypeV2<'uhdrsMotorRatingScale'>>;
}

export default MotorFuncHuntDash;
